import { getIsCandidateForOutlookLite } from './utils/getIsCandidateForOutlookLite';
import { getQueryStringParameter } from 'owa-querystring';

const KRS_LINK = 'https://aka.ms/krs';
const DEFAULT_OM_ID = 'bGsTHYad';

/**
 * This file is the entry point for the Outlook Lite Referral Bootstrap package.
 * It is responsible for redirecting the user to the appropriate Play Store link
 */
export const bootstrap = () => {
    const omId = getQueryStringParameter('omid');
    const liteId = getQueryStringParameter('liteid');
    const isCandidateForOutlookLite = getIsCandidateForOutlookLite();

    let redirectToUrl = `${KRS_LINK}?id=${DEFAULT_OM_ID}`;

    if (isCandidateForOutlookLite) {
        redirectToUrl = `${KRS_LINK}?id=${liteId}`;
    } else {
        redirectToUrl = `${KRS_LINK}?id=${omId}`;
    }

    window.location.href = redirectToUrl;
};
